{
  "_description": "Maps internal GeoEvent Server property names to human-readable labels as shown in the GeoEvent Server application and help documentation. Add new entries as needed.",
  "acceptableMimeTypes": "Acceptable MIME Types",
  "accessToken": "Access Token",
  "accessTokenSecret": "Access Token Secret",
  "accumulateIdleDuration": "Accumulate Idle Duration",
  "accuracy": "Accuracy (Precision Level)",
  "airlineFilter": "Airline Filter (ICAO Codes)",
  "airportFilter": "Airport Filter",
  "allowDuplicates": "Allow Duplicates",
  "arcgisServerConnection": "ArcGIS Server Connection",
  "asGeoJSON": "Parse as GeoJSON",
  "AttributeSeparator": "Attribute Separator",
  "attributeSeparatorToBeReplaced": "Attribute Separator Pattern (Regex)",
  "automaticResetCache": "Automatic Reset Cache",
  "baseFileName": "Base File Name",
  "bearing": "Bearing Field",
  "body": "Message Body",
  "bootstrapServers": "Bootstrap Servers",
  "bufferDistance": "Buffer Distance",
  "bufferwkid": "Buffer Spatial Reference",
  "clearCache": "Clear Cache",
  "clearInMemoryCache": "Clear In-Memory Cache",
  "clientConnectionTimeout": "Client Connection Timeout (seconds)",
  "clientParameters": "Client URL Parameters",
  "clientURL": "Client URL",
  "closingCondition": "Closing Condition",
  "collectionName": "Collection Name",
  "connectionTimeout": "Connection Timeout (seconds)",
  "constructGeometryFromFields": "Construct Geometry from Fields",
  "consumerGroupId": "Consumer Group ID",
  "consumerKey": "Consumer Key",
  "consumerSecret": "Consumer Secret",
  "count": "Tweet Count",
  "countNotificationMode": "Notification Mode",
  "createBearingSegment": "Create Bearing Segment",
  "createGeoEventDefinition": "Create GeoEvent Definition",
  "createUnrecognizedEventDefinitions": "Create Unrecognized Event Definitions",
  "curveType": "Curve Type",
  "customerName": "Customer Name",
  "customLayerUrl": "Feature Layer URL",
  "database": "Database",
  "databaseName": "Database Name",
  "dataJoinFieldName": "Data Join Field Name",
  "dataRetention": "Data Retention",
  "dataTypes": "Data Types",
  "defaultSpatialReference": "Default Spatial Reference",
  "delayTime": "Delay Time",
  "delayTimeField": "Delay Time Field",
  "delayTimeUnit": "Delay Time Unit",
  "deleteOldFeatures": "Delete Old Features",
  "densifyFlightPlanPolylines": "Densify Flight Plan Polylines",
  "destinationSource": "Destination Source",
  "distanceUnit": "Distance Unit",
  "downloadMetadata": "Download Metadata",
  "dynamicWorkOrder": "Dynamic Work Order",
  "endTime": "End Time",
  "enforceDelayThreshold": "Enforce Delay Threshold",
  "enrichmentFields": "Enrichment Fields",
  "envelopeAreaOfInterests": "Envelope Areas of Interest",
  "eventFieldName": "Event Field Name",
  "eventGeometryField": "Event Geometry Field",
  "eventJoinFieldName": "Event Join Field Name",
  "eventSeparator": "Event Separator",
  "eventWindowSize": "Event Window Size",
  "exchangeAutoDelete": "Auto-Delete Exchange",
  "exchangeDurability": "Exchange Durability",
  "exchangeName": "Exchange Name",
  "exchangeType": "Exchange Type",
  "exclusiveQueue": "Exclusive Queue",
  "existingFieldName": "Existing Field Name",
  "expectedDateFormat": "Expected Date Format",
  "expirationCheckRate": "Expiration Check Rate (seconds)",
  "expiryTime": "Expiry Time (seconds)",
  "expression": "Expression",
  "feedTypeGroup": "Feed Type Group",
  "fields": "Fields",
  "fieldSeparator": "Field Separator",
  "fieldSplitter": "Field Splitter Delimiter",
  "fieldsToRemove": "Fields to Remove",
  "fieldToSplit": "Field to Split",
  "filePath": "File Path",
  "filterIMO": "IMO Filter",
  "filterMessageTypeID": "Message Type ID Filter",
  "filterMMSI": "MMSI Filter",
  "flightAwareHost": "FlightAware Firehose Host",
  "flightIdentifications": "Flight Identifications",
  "folder": "Folder",
  "follow": "Follow IDs",
  "formattedJson": "Formatted JSON",
  "frequency": "Frequency (in seconds)",
  "generateFlatJson": "Generate Flat JSON",
  "geoEventDefinitionName": "GeoEvent Definition Name",
  "geofence": "Geofence Filter",
  "geoMessageType": "GeoMessage Type",
  "geometryField": "Geometry Field",
  "geometryFieldName": "Geometry Field Name",
  "geometryType": "Geometry Type",
  "handshakeText": "Handshake Text",
  "headerParameters": "Header Parameters",
  "headers": "HTTP Headers",
  "host": "Server Host",
  "hostName": "Host Name",
  "httpMethod": "HTTP Method",
  "httpTimeout": "HTTP Timeout (seconds)",
  "idleNotificationMode": "Idle Notification Mode",
  "incidentName": "Incident Name",
  "incidentType": "Incident Type",
  "incomingDataContainsGeoEventDefinition": "Incoming Data Contains GeoEvent Definition",
  "inputBatchFlushIntervalInMS": "Batch Flush Interval (ms)",
  "inputDeleteFiles": "Delete Files After Processing",
  "inputFields": "Input Fields",
  "inputFileFilter": "File Filter Pattern",
  "inputFolderDataStore": "Input Folder Data Store",
  "inputGeometryField": "Input Geometry Field",
  "interval": "Interval",
  "isTextFormat": "Parse as Text",
  "jmsDestinationName": "JMS Destination Name",
  "jmsDestinationType": "JMS Destination Type",
  "joinFieldName": "Join Field Name",
  "joinGEDName": "Join GeoEvent Definition Name",
  "jsonObjectName": "JSON Object Name",
  "keepFields": "Keep Fields",
  "keepSourceFields": "Keep Source Fields",
  "languageForNumberFormatting": "Language for Number Formatting",
  "layer": "Layer",
  "learningMode": "Learning Mode",
  "locations": "Locations Filter",
  "maxEventCount": "Maximum Event Count",
  "maxFeatures": "Maximum Features",
  "maxFeaturesPerTransaction": "Maximum Features Per Transaction",
  "maxGapDuration": "Maximum Gap Duration",
  "maximumFeaturesPerTransaction": "Maximum Features Per Transaction",
  "maximumLatitude": "Maximum Latitude",
  "maximumLongitude": "Maximum Longitude",
  "maximumTimeAllowedForIdling": "Maximum Time Allowed for Idling (seconds)",
  "maxRowCount": "Maximum Row Count",
  "maxSegmentLength": "Max Segment Length (meters)",
  "message": "Message",
  "MessageSeparator": "Message Separator",
  "metaDataUpdateInterval": "Metadata Update Interval (minutes)",
  "mgrsField": "MGRS Field",
  "minimumLatitude": "Minimum Latitude",
  "minimumLongitude": "Minimum Longitude",
  "mode": "Connection Mode",
  "multicastGroup": "Multicast Group",
  "newGeoEventDefinitionName": "New GeoEvent Definition Name",
  "newGeometryFieldName": "New Geometry Field Name",
  "notificationType": "Notification Type",
  "openingCondition": "Opening Condition",
  "operatorTypeFilter": "Operator Type Filter",
  "originSource": "Origin Source",
  "outputBaseFileName": "Output Base File Name",
  "outputBearingField": "Output Bearing Field",
  "outputDefinitionName": "Output GeoEvent Definition Name",
  "outputDirectory": "Output Directory",
  "outputFields": "Output Fields",
  "outputFileExtension": "Output File Extension",
  "outputFileFooter": "File Footer",
  "outputFileFrequency": "File Rotation Frequency",
  "outputFileHeader": "File Header",
  "outputFileSizeLimitMethod": "File Size Limit Method",
  "outputFileSizeLimitValue": "File Size Limit (KB)",
  "outputFolderDataStore": "Output Folder Data Store",
  "outputGeoEventDefinitionSuffixName": "Output GeoEvent Definition Suffix",
  "outputGeometryField": "Output Geometry Field",
  "outwkid": "Output Spatial Reference (WKID)",
  "overlayGeometryField": "Overlay Geometry Field",
  "overlayType": "Overlay Type",
  "overwriteGeometry": "Overwrite Geometry",
  "parameters": "URL Parameters",
  "partiesGeofencesCategory": "Parties Geofences Category",
  "password": "Password",
  "phoneNumber": "Phone Number",
  "pollingFrequency": "Polling Frequency",
  "polygonAreaOfInterests": "Polygon Areas of Interest",
  "port": "Server Port",
  "portNumber": "Port Number",
  "postContentType": "POST Content Type",
  "predictiveTimespan": "Predictive Timespan (seconds)",
  "providerURL": "Provider URL",
  "qosLevel": "MQTT QoS Level",
  "qualityOfService": "Quality of Service (QoS)",
  "queryDefinition": "Query Definition",
  "queueAutoDelete": "Auto-Delete Queue",
  "queueDurability": "Queue Durability",
  "queueName": "Queue Name",
  "range": "Range",
  "rangeUnit": "Range Unit",
  "rateLimit": "Rate Limit (seconds)",
  "rateLimitAirborne": "Airborne Rate Limit",
  "rateLimitSurface": "Surface Rate Limit",
  "referenceToLayerType": "Reference to Layer Type",
  "refreshInterval": "Polling Interval (seconds)",
  "regexExpression": "Regular Expression",
  "rendezvoussGeofencesCategory": "Rendezvous Geofences Category",
  "rendezvoussProximity": "Rendezvous Proximity",
  "rendezvoussSpatialReference": "Rendezvous Spatial Reference",
  "repeatCount": "Repeat Count",
  "repeatInterval": "Repeat Interval",
  "replaceGeometry": "Replace Geometry",
  "reportIdleDurationWhileNotIdle": "Report Idle Duration While Not Idle",
  "reportInterval": "Report Interval (seconds)",
  "resetCacheAt": "Reset Cache At",
  "resultDestination": "Result Destination",
  "resultingGeoEventDefinitionName": "Resulting GeoEvent Definition Name",
  "retainMessages": "Retain Messages",
  "returnBoundingBox": "Return Bounding Box",
  "routingKey": "Routing Key",
  "searchRadius": "Search Radius",
  "serverPort": "Server Port",
  "service": "Service",
  "serviceLayerUrl": "Service Layer URL",
  "serviceName": "Service Name",
  "severity": "Severity",
  "smtpHost": "SMTP Host",
  "smtpPort": "SMTP Port",
  "sourceField": "Source Field",
  "sourceURL": "Source URL",
  "spatialOperator": "Spatial Operator",
  "spatialRelationship": "Spatial Relationship",
  "ssl": "Use SSL",
  "startTime": "Start Time",
  "streamServiceUrl": "Stream Service URL",
  "strictUnblocking": "Strict Unblocking",
  "subject": "Subject",
  "targetField": "Target Field",
  "timeout": "Timeout (seconds)",
  "timeRange": "Time Range",
  "timeUnit": "Time Unit",
  "timeWindow": "Time Window",
  "to": "To Recipients",
  "tolerance": "Tolerance",
  "topic": "Topic",
  "topicName": "Topic Name",
  "track": "Track Keywords",
  "trackIdField": "Track ID Field",
  "traversal": "Traversal",
  "uniqueFeatureIdentifier": "Unique Feature Identifier",
  "uniqueFeatureIdentifierField": "Unique Feature Identifier Field",
  "unit": "Distance Unit",
  "updateInterval": "Update Interval (seconds)",
  "url": "URL",
  "urlParameters": "URL Parameters",
  "useCompression": "Use Compression",
  "useEndTime": "Use End Time",
  "useEventCount": "Use Event Count",
  "useLocation": "Use Location",
  "useLongPolling": "Use Long Polling",
  "username": "Username",
  "userName": "User Name",
  "useScheduledTime": "Use Scheduled Time",
  "useTrackId": "Use Track ID",
  "useUrlProxy": "Use URL Proxy",
  "virtualHost": "Virtual Host",
  "workOrderTemplate": "Work Order Template",
  "workOrderTemplateIDField": "Work Order Template ID Field",
  "workOrderTemplateIds": "Work Order Template IDs",
  "writeEmptyStringValues": "Write Empty String Values",
  "writeNullValues": "Write Null Values",
  "xField": "X Field",
  "xGeometryField": "X Geometry Field",
  "yField": "Y Field",
  "yGeometryField": "Y Geometry Field",
  "zField": "Z Field",
  "zGeometryField": "Z Geometry Field"
}
